module.exports = __webpack_public_path__ + "static/media/test.b4387913.svg";